import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { Paper, IconButton } from "@mui/material";
import { Search } from "@mui/icons-material";

const SearchBar = () => {

const [searchTerm, setSearchTerm] = useState('')
const navigate = useNavigate();
const handleSearch = (e) => {
    e.preventDefault();
    if(searchTerm){
        navigate(`/search/${searchTerm}`)

        setSearchTerm('');
    }
}

  return (
   <Paper 
    className="search"
    component="form"
    onSubmit={handleSearch}
    sx={{
        background: '#121212',
        borderRadius: '20px',
        boxShadow: 'none',
        border: '1px solid #3d3d3d',
        pl :'10px',
        mr: { sm:5 }
    }}
   >
    <input 
        className="search-bar"
        type="text" 
        placeholder="Search"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
    />
    <IconButton sx={{ p: '10px', color: 'red' }}>
        <Search />
    </IconButton>
   </Paper>
  )
};

export default SearchBar;
